import { format } from "date-fns";

export const waitSeconds = (seconds: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, seconds * 1000);
  });
};

export const getQueryStringParams = (options: any, keyPrefix: string = '') : string => {
  const dateFormat = "yyyy-MM-dd";

  return Object.keys(options).reduce((result: string[], key: string) => {
    const value = options[key];
    if (value !== undefined && value !== null && value !== '') result.push(key);
    return result;
  }, [])
  .map(key => {
    let prefixedKey = keyPrefix.length > 0 ? `${keyPrefix}.${key}` : key;
    const value = options[key];
    
    if (Array.isArray(value)) {
      return value.map((item: any, index: number) => {
        prefixedKey = `${prefixedKey.replace(/\[\w+\]$/g, '')}[${index}]`
        return typeof item === 'object'
          ? getQueryStringParams(item, prefixedKey)
          : `${prefixedKey}=${encodeURIComponent(item)}`;
      }).join('&');
    }

    if (Object.prototype.toString.call(value) === '[object Date]' && !isNaN(value)) {
      return `${prefixedKey}=${format(value, dateFormat)}`
    }

    if (typeof value === 'object') {
      return getQueryStringParams(value, prefixedKey);
    }

    return `${prefixedKey}=${encodeURIComponent(value)}`;
  }).join('&');
};

export const downloadCsvFile = (csvContent: string, filename: string = 'export.csv'): void => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

export const copyTextToClipboardAsync = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
  }
  catch (error) {
    console.error('Failed to copy text: ', error);
  }
};